var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"max-width":"485px"},on:{"click:outside":_vm.emitClose}},[_c('div',{staticClass:"contact-dialog"},[_c('img',{staticClass:"contact-dialog__close",attrs:{"src":require("@/assets/landing/close.svg")},on:{"click":_vm.emitClose}}),_c('ContactUsContent',{on:{"close":_vm.emitClose}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }